module.exports = __webpack_public_path__ + "img/ht.7f45292c.svg";